<template>
  <div>
    <div class="paragraph">
      1、未中标供应商保证金，在项目结束当天系统自动发起退款，5日内有息退款至打款账户。
    </div>
    <div class="paragraph">
      2、成交供应商保证金在项目结束后，如果业主/代理机构设置审核保证金退款，则需要业主/代理机构
      <span class="text-danger">同意退款</span>
      且成交供应商
      <span class="text-danger">支付完平台服务费</span>
      两者达成的当天系统自动有息退款至打款账户。如果业主/代理机构未设置审核保证金退款，成交供应商支付完平台服务费当天统自动有息退款至打款账户。
    </div>
    <div class="paragraph">
      3、流标项目，所有供应商单位保证金在流标当天系统自动有息退款至打款账户。
    </div>
    <div class="paragraph">
      4、如果保证金退款状态为已冻结，则需联系项目负责人协商解冻后，才可退回。
    </div>
  </div>
</template>

<script>
export default {
  name: 'GFeeBackRuleCopywriter'
}
</script>
